import { gql } from '@apollo/client'
import type { TypedDocumentNode } from '@graphql-typed-document-node/core'

import type {
    AddEventQuery,
    AddEventQueryVariables,
} from './Add.queries.generated'

export const Query: TypedDocumentNode<AddEventQuery, AddEventQueryVariables> =
    gql`
        query AddEvent($guid: String!) {
            entity(guid: $guid) {
                ... on Entity {
                    guid
                }

                ... on Event {
                    startDate
                }
            }
        }
    `
